(function () {
  var SESSION_KEY = 'hr_loaded';

  /* 2回目以降はスキップ */
  if (sessionStorage.getItem(SESSION_KEY)) {
    var overlay = document.getElementById('tea-loading');
    if (overlay) overlay.remove();
    return;
  }
  sessionStorage.setItem(SESSION_KEY, '1');

  var overlay = document.getElementById('tea-loading');
  var canvas  = document.getElementById('tea-loading-canvas');
  if (!overlay || !canvas) return;

  var ctx = canvas.getContext('2d');
  var W, H, particles = [], animId, done = false;

  function resize() {
    W = canvas.width  = window.innerWidth;
    H = canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  /* ── ゴールドの光の粒子 ── */
  function Particle() { this.reset(true); }

  Particle.prototype.reset = function (initial) {
    this.x = Math.random() * W;
    this.y = initial ? Math.random() * H : H + 10;
    this.r = Math.random() * 1.8 + 0.4;
    this.vx = (Math.random() - 0.5) * 0.4;
    this.vy = -(Math.random() * 0.6 + 0.2);
    this.alpha = 0;
    this.maxAlpha = Math.random() * 0.45 + 0.1;
    this.life = 0;
    this.maxLife = Math.random() * 180 + 100;
    /* ゴールド〜シャンパン */
    var hues = ['184,151,90', '212,184,122', '180,174,152', '200,168,100'];
    this.color = hues[Math.floor(Math.random() * hues.length)];
  };

  Particle.prototype.update = function () {
    this.life++;
    var t = this.life / this.maxLife;
    /* フェードイン → 維持 → フェードアウト */
    this.alpha = t < 0.15
      ? this.maxAlpha * (t / 0.15)
      : t > 0.7
        ? this.maxAlpha * (1 - (t - 0.7) / 0.3)
        : this.maxAlpha;
    this.x += this.vx;
    this.y += this.vy;
    if (this.life >= this.maxLife) this.reset(false);
  };

  Particle.prototype.draw = function () {
    ctx.save();
    /* グロー効果 */
    ctx.shadowBlur  = 6;
    ctx.shadowColor = 'rgba(' + this.color + ',0.6)';
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(' + this.color + ',' + this.alpha.toFixed(3) + ')';
    ctx.fill();
    ctx.restore();
  };

  /* ── 初期化 ── */
  var COUNT = 55;
  for (var i = 0; i < COUNT; i++) {
    var p = new Particle();
    p.life = Math.floor(Math.random() * p.maxLife);
    particles.push(p);
  }

  /* ── 描画ループ ── */
  function draw() {
    if (done) return;
    ctx.clearRect(0, 0, W, H);

    /* アイボリーの淡いビネット */
    var grad = ctx.createRadialGradient(W / 2, H / 2, H * 0.05, W / 2, H / 2, H * 0.9);
    grad.addColorStop(0, 'rgba(249,246,241,0)');
    grad.addColorStop(1, 'rgba(232,226,217,0.35)');
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, W, H);

    particles.forEach(function (p) { p.update(); p.draw(); });
    animId = requestAnimationFrame(draw);
  }

  /* ── フェードアウト ── */
  function startFade() {
    done = true;
    if (animId) cancelAnimationFrame(animId);
    overlay.classList.add('is-hidden');
    setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 1100);
  }

  /* ── 開始 ── */
  function start() {
    draw();
    window.addEventListener('load', function () {
      setTimeout(startFade, 2200);
    });
    /* フォールバック */
    setTimeout(startFade, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
